// src/json/servicesOverview.json
export const servicesOverviewCommercialExteriorPainting = {
    eyebrow: "OUR COMMERCIAL EXTERIOR",
    titleHighlight: "PAINTING SERVICES INCLUDE:",
    items: [
        {
            title: "High-Rise & Mid-Rise Building Painting",
            description: "Specialized coatings designed for durability and weather resistance on multi-story buildings."
        },
        {
            title: "Concrete, Stucco & Masonry Painting",
            description: "Protective coatings to reinforce and revitalize exterior surfaces."
        },
        {
            title: "Metal & Structural Steel Coatings",
            description: "Corrosion-resistant paints that extend the life of railings, beams, and other metal components."
        },
        {
            title: "Elastomeric & Waterproof Coatings",
            description: "Flexible, high-build coatings that seal surfaces and protect against water infiltration."
        },
        {
            title: " Color Matching & Custom Finishes",
            description: "Tailored solutions to maintain or refresh your building’s brand identity and aesthetic appeal."
        }
    ],
    imageUrl: "/assets/imgs/services/3CommercialExteriorPainting/servicesOverview/fondo.png",
    button: {
        text: "Request a Quote",
        url: "/quote"
    }
};  